import CancelOrderDialogOptionsForm from '@/components/OrdersModule/OrderDetail/CancelOrderDialog/CancelOrderDialogOptionsForm'
import InsertNoteFormContent from '@/features/common/components/InsertNoteFormContent'
import { useInsertNoteFormComponent } from '@/features/common/components/InsertNoteFormContent/hooks/useInsertNoteFormComponent'
import Modal from '@/features/ui/components/Modal'
import { CancelOrderReason } from '@/types/cancelOrder'
import { useHeaderHeight } from '@react-navigation/elements'
import { FC, useState } from 'react'
import { ScrollView } from 'react-native'

interface CancelOrderDialogProps {
    uuid: string
    onDismiss: () => void
}

const CancelOrderDialog: FC<CancelOrderDialogProps> = ({ uuid, onDismiss }) => {
    const headerHeight = useHeaderHeight()
    const [reason, setReason] = useState<CancelOrderReason>('customer')
    const [returnMoney, setReturnMoney] = useState(false)

    const [confirmedNoteRef, { isEdit, toggle }, actions] = useInsertNoteFormComponent()

    const handleReasonChange = (reason: CancelOrderReason) => setReason(reason)

    return (
        <Modal
            avoidKeyboard={isEdit}
            keyboardAvoidanceVariant="padding"
            keyboardVerticalOffset={headerHeight}
        >
            {!isEdit ? (
                <CancelOrderDialogOptionsForm
                    uuid={uuid}
                    reason={reason}
                    returnMoney={returnMoney}
                    confirmedNote={confirmedNoteRef.current}
                    onReasonChange={handleReasonChange}
                    onReturnMoneyChange={setReturnMoney}
                    onDismiss={onDismiss}
                    onNoteButtonPress={toggle}
                />
            ) : (
                <ScrollView
                    keyboardShouldPersistTaps="handled"
                    showsVerticalScrollIndicator={false}
                >
                    <InsertNoteFormContent confirmedNote={confirmedNoteRef.current} {...actions} />
                </ScrollView>
            )}
        </Modal>
    )
}

export default CancelOrderDialog
